import { ApolloClient, InMemoryCache } from "@apollo/client";
import { HttpLink } from "@apollo/client/link/http";

// Better-auth uses cookies for authentication, so we need to include credentials
const httpLink = new HttpLink({
  uri: `${(import.meta.env.VITE_API_URL as string) || ""}/graphql`,
  credentials: "include", // Include cookies in requests
});

export const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
  },
});
